import { FileType } from "../constants";
import { axiosInstance } from "../services/axios";


export const downloadCSV = async (path: string, fileName: string) => {
    try {
        const element = document.createElement("a");
        const response = await axiosInstance.get(
            path
        );    
        let decodedResponse = atob(response?.data?.reportData);
        
        const blob = decodedResponse;
        const file = new Blob([blob], {
            type: FileType.octetStream,
        });
        const currentDateTime = new Date().toISOString();
        element.href = URL.createObjectURL(file);
        element.download = fileName + "_" + currentDateTime + ".csv";
        document.body.appendChild(element);
        element.click();
    } catch (error: any) {
        console.log(error);
    }
};